import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:managePetList
 * @description
 * # managePetList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'managePetList',
    ($http, ENV, $ngRedux, $scope, $rootScope, $location, $timeout, $route) => {
      if (!$scope.isAdminUser) {
        $location.path('/');
      }
      $rootScope.userId = null;

      $scope.processParams = () =>
        new Promise((resolve) => {
          const { petId, petDetailId } = $route.current.params;
          if (petId === 'create-pet') {
            $rootScope.onCreatePet();
          } else if (petId) {
            $scope.onEditPet({ petId: petId });
          } else if (petDetailId) {
            $scope.onSelectPet({ petId: petDetailId });
          }
          resolve(true);
        });

      $scope.init = () => {
        $rootScope.previousRoute = $rootScope.routes.pet;
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.processParams();
      };

      $scope.output = {};

      $scope.update_notes = (pet) => {
        if (pet.id != null) {
          let submitData = {
            pet: {
              clinic_tag: pet.notes,
            },
          };
          $scope.updateProPet($http, ENV, pet.id, submitData).then(() => {
              $timeout(() => {
                $scope.output[pet.id] = 'Changes have been saved.';
                $timeout(() => {
                  delete $scope.output[pet.id];
                }, 10000);
              });
            },
            (response) => {
              $timeout(() => {
                if (response.status !== 200) {
                  $scope.output[pet.id] = 'Not saved. Try again.';
                  $timeout(() => {
                    delete $scope.output[pet.id];
                  }, 10000);
                }
              });
            },
          );
        }
      };

      $scope.table = {
        name: 'Manage Pets',
        options: {
          endpoint: '/2.0/pets/',
          endpoint_data_key: 'pets',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: false,
          search_key: 'Pets',
          search_required: true,
        },
        actions: [
          {
            name: 'Create a Pet',
            link: '#',
            onclick: () => {
              $rootScope.onCreatePet();
            },
            order: 0,
            superuser: false,
          },
        ],
        columns: [
          {
            name: 'Last Online',
            options: {
              content: '{{ record.last_online | date:"yyyy-MM-dd HH:mm:ss" }}',
         
         
              class: '',
            },
          },
          {
            name: 'User',
            options: {
              content:
                '<div ng-repeat="user in record.owner_relationships"><div ng-if="user.primary == true">' +
                '<a ng-if="user.user.first_name || user.user.last_name" href="#" ng-href="/admin/users/manage-users/{{ user.user.id }}">' +
                '{{ user.user.first_name }} {{ user.user.last_name }}' +
                '</a>' +
                '<br ng-if="user.user.contact_information.email && (user.user.first_name || user.user.last_name)" />' +
                '<a ng-class="{\'small email\': (user.user.first_name || user.user.last_name)}" ng-if="user.user.contact_information.email" href="#" ng-href="/admin/users/manage-users/{{ user.user.id }}">' +
                '{{ user.user.contact_information.email }}' +
                '</a></div></div>',
              class: 'td-user',
            },
          },
          {
            name: 'Pet',
            options: {
              content:
                '<a href="#" ng-click="onSelectPet({petId: record.id})">{{record.name}}</a><br />' +
                '{{ record.is_male ? "Male" : "Female" }}<span ng-if="record.age_information.breed_age != null">: {{ record.age_information.breed_age }}</span><br />' +
                '<span class-"italic" ng-if="record.date_created">Created: {{ record.date_created | dateInMMDDYYYWithHyphen }}</span>',
              class: 'td-user',
            },
          },
          {
            name: 'Species/Breed',
            options: {
              content:
                '<span ng-if="record.breed && record.breed.species && record.breed.species.name">{{ record.breed.species.name }}</span>' +
                '<br ng-if="record.breed.species.name" /><span ng-if="record.breed && record.breed.name">{{ record.breed.name }}</span>',
              class: 'species-breed-column',
            },
          },
          {
            name: 'Organization(s)',
            options: {
              content:
                '<ul><li ng-repeat="org in record.providers">{{ org.organization.name }}</li></ul>',
              class: 'list-column',
            },
          },
          {
            name: 'Notes/Action',
            options: {
              content:
                '<a class="pet-link" href="#" ng-click="onEditPet({petId: record.id})">Edit Pet</a>' +
                '<input ng-if="record.is_active" type="text" placeholder="Enter Notes" class="notes-input" ng-model="record.notes" ng-model-options="{ updateOn: \'blur\' }" ng-change="update_notes(record, $index);" />' +
                '<span class="update-text">{{ output[record.id] }}</span>',
              class: 'td-action pet-column',
            },
          },
        ],
        filters: [
          {
            name: 'Pet Owner',
            type: 'angucomplete',
            options: {
              class: 'user-filter above-divider',
              query_string_parameter: 'user_id',
              remove_all: true,
              remove_all_key: 'users',
              search_endpoint: '/2.0/users/?groups=2',
              search_endpoint_data_key: 'data',
              selected: [],
              selected_key: ['first_name', 'last_name'],
              selected_remove_key: 'id',
            },
            angucomplete_parameters: {
              id: 'user-name',
              placeholder: 'User Name',
              pause: 1000,
              datafield: 'users',
              isclearafterselect: true,
              selectedobject: 'nameEmail',
              searchfields: 'first_name,last_name,email',
              titlefield: 'first_name,last_name',
              descriptionfield: ['contact_information', 'email'],
              minlength: 2,
              inputclass: 'form-control form-control-small',
              matchclass: 'highlight',
              searchfn: $scope.filterUsers,
              nextfn: $scope.filterUsersPage,
              onselect: $scope.setSelectedUsers,
              preselected: [],
              isUser: true,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Pet Status',
            type: 'single_choice',
            options: {
              choices: {
                Active: { type: 'standard', state: true, value: 'true', order: 0 },
                Archived: { type: 'standard', state: false, value: 'false', order: 1 },
              },
              class: '',
              name_attribute: 'name',
              query_string_parameter: 'is_active',
              select_all: false,
            },
          },
          {
            name: 'Pet Species',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/pets/species/',
              choices_endpoint_data_key: 'pets-species',
              class: 'above-divider',
              name_attribute: 'name',
              query_string_parameter: 'species',
              select_all: true,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Application Subscription',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/applications/',
              choices_endpoint_data_key: 'applications',
              class: 'application-filter above-divider',
              name_attribute: 'name',
              no_selected_parameter: 'none',
              query_string_parameter: 'application_subscription',
              select_all: true,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Organizations',
            type: 'angucomplete',
            options: {
              class: 'organization-filter',
              query_string_parameter: 'organizations',
              remove_all: true,
              remove_all_key: 'organizations',
              search_endpoint: '/2.0/organizations/',
              search_endpoint_data_key: 'data',
              selected: [],
              selected_key: ['name'],
              selected_remove_key: 'id',
            },
            angucomplete_parameters: {
              id: 'organization-name',
              placeholder: 'Organization Name',
              pause: 1000,
              datafield: 'organizations',
              isclearafterselect: true,
              selectedobject: 'name',
              searchfields: 'name',
              titlefield: 'name',
              descriptionfield: null,
              minlength: 2,
              inputclass: 'form-control form-control-small',
              matchclass: 'highlight',
              searchfn: $scope.filterOrganizations,
              nextfn: $scope.filterOrganizationsPage,
              onselect: $scope.setSelectedOrganizations,
              preselected: [],
              isUser: false,
            },
          },
        ],
        sort_options: {
          owner__last_login: {
            state: false,
            value: '1',
            title: 'Last Online',
            order: 0,
          },
          date_created: {
            state: true,
            value: '-1',
            title: 'Date Created',
            order: 1,
          },
          name: {
            state: false,
            value: '1',
            title: "Pet's Name",
            order: 2,
          },
          owner__last_name: {
            state: false,
            value: '1',
            title: "User's Name",
            order: 3,
          },
        },
      };

      $scope.$on('$routeChangeStart', async (event, current) => {
        if (!current?.params?.petId) {
          $rootScope.userId = null;
        }
      });

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
